<div class="app-wrapper" [ngClass]="{'rtl': this.directionService.direction==='rtl'}" [dir]="this.directionService.direction==='rtl' ? 'rtl': 'ltr'">
  <router-outlet></router-outlet>
  <ngx-spinner [fullScreen]="true" bdColor="rgba(0, 0, 0, 0.8)" color="#fff" size="medium"
               type="ball-clip-rotate-multiple"><p style="color: white"> Loading... </p></ngx-spinner>
</div>
